document.addEventListener('DOMContentLoaded', function () {
  const searchBox = document.querySelector('.SiteHeader--root');
  const menu = document.querySelector('.SiteMobileNavigation--root');
  const menuIcon = document.querySelector('.SiteMobileHeader--menu-toggle');
  const searchField = document.querySelector('.MainSearchBar--search-field');

  const toggleSearchBox = () => {
    if (searchBox.classList.contains('SiteHeader--search-is-open')) {
      searchBox.classList.remove('SiteHeader--search-is-open');
    } else {
      searchBox.classList.add('SiteHeader--search-is-open');
      searchField.focus();
      menu.classList.remove('SiteMobileNavigation--nav-show');
      menuIcon.classList.remove('SiteMobileHeader--menu-toggle-is-active');
    }
  };

  const closeSearchBox = () => {
    searchBox.classList.remove('SiteHeader--search-is-open');
  };

  document.addEventListener('click', (event) => {
    const isSearchButtonClick =
      event.target.closest('.MainHeader--search-section') ||
      event.target.closest('.SiteMobileHeader--search-section') ||
      event.target.closest('.SearchPage--search-again');

    const isClickOutside =
      !event.target.closest('.SiteHeader--root') &&
      !event.target.closest('.MainHeader--root') &&
      !event.target.closest('.SiteMobileHeader--root');

    if (isSearchButtonClick) {
      toggleSearchBox();
    } else if (isClickOutside) {
      closeSearchBox();
    }
  });

  window.addEventListener('load', function () {
    let searchTerm = document.querySelector('.SearchPage--search-query');
    let searchResultsCount = document.querySelector('.SearchPage--total-records');
    const searchPage = document.referrer;

    // Only grab the text input into the search field if it actually exists on the page
    if (searchTerm) {
      searchTerm = searchTerm.innerText;
    }

    // Only grab the number of search results if the element actually exists on the page
    if (searchResultsCount) {
      searchResultsCount = searchResultsCount.value;
    }

    if (searchTerm && window.ltanalytics) {
      window.ltanalytics.push([
        'track',
        'Search Performed',
        {
          search_term: searchTerm || '',
          search_results_count: searchResultsCount || '',
          search_page: searchPage || '',
        },
      ]);
    }
  });

  const searchResultElements = document.querySelectorAll('.SearchResult--title');
  if (searchResultElements.length > 0 && window.ltanalytics) {
    searchResultElements.forEach((element) => {
      element.addEventListener('click', function (event) {
        window.ltanalytics.push([
          'track',
          'Search Result Clicked',
          {
            search_result_clicked: event.target.innerText || '',
          },
        ]);
      });
    });
  }
});
